<template>
  <div class="flex flex-col" :class="$style.root">
    <AppModal
      v-if="$store.get('trainSchedule/showSelectOperatorModal')"
      :width="400"
      :height="400"
    >
      <template v-slot:header>
        Välj tåg
      </template>
      <TimetableSelectOperatorModal />
    </AppModal>
    <TimetableToolbar />
    <multipane
      class="splitview h-full"
      layout="horizontal"
      :style="{ maxHeight: 'calc(100% - 48px)' }"
    >
      <div :style="heightStyles" class="overflow-auto">
        <AppTransition name="fade-in">
          <AppLoadingScreen v-if="$store.get('trainSchedule/pending')">
            Hämtar tidtabell...
          </AppLoadingScreen>
          <AppEmptyState
            icon="info"
            v-else-if="!$store.get('trainSchedule/allList').length"
            >Ingen data hittades...
            <template v-slot:helper>
              Försök med en ny sökning!
            </template>
          </AppEmptyState>

          <TimetableGantt v-else />
        </AppTransition>
      </div>
      <TimetableSplitViewHandleBar />
      <div
        class="bg-white flex-grow overflow-auto"
        :style="{ height: '100px' }"
      >
        <template v-if="$store.get('trainSchedule/allList').length">
          <AppTransition name="fade-in">
            <AppEmptyState
              icon="info"
              v-if="
                !$store.get('trainChange/pending') &&
                  !$store.get('trainChange/inited')
              "
              >Välj ett datum för att visa händelser
            </AppEmptyState>
            <AppLoadingScreen v-else-if="$store.get('trainChange/pending')">
              Hämtar händelser...
            </AppLoadingScreen>
            <AppEmptyState
              icon="info"
              v-else-if="!$store.get('trainChange/active')"
              >Inga händelser hittades...
              <template v-slot:helper>
                Försök med ett annat datum!
              </template>
            </AppEmptyState>
            <TimetableSplitView v-else />
          </AppTransition>
        </template>
      </div>
    </multipane>
  </div>
</template>

<script>
import { Multipane } from 'vue-multipane'

import TimetableSplitViewHandleBar from '@/components/Timetable/TimetableSplitViewHandleBar'
import TimetableSplitView from '@/components/Timetable/TimetableSplitView'
import TimetableToolbar from '@/components/Timetable/TimetableToolbar'
import TimetableGantt from '@/components/Timetable/TimetableGantt'
import TimetableSelectOperatorModal from '@/components/Timetable/TimetableSelectOperatorModal'

import { get } from 'vuex-pathify'

export default {
  name: 'Timetable',

  components: {
    TimetableToolbar,
    TimetableGantt,
    TimetableSplitView,
    TimetableSplitViewHandleBar,
    Multipane,
    TimetableSelectOperatorModal
  },

  created() {
    this.$store.dispatch('migratedPlan/fetch')
  },

  computed: {
    months: get('timetable/months'),

    ganttHeight() {
      const scrollbarWidth = this.$store.get('app/scrollbarWidth')
      return this.months.length * 32 + 24 + scrollbarWidth + 'px'
    },

    heightStyles() {
      if (!this.$store.get('trainSchedule/allList').length) {
        return { height: '100%' }
      }
      return {
        minHeight: '100px',
        height: this.ganttHeight,
        maxHeight: this.ganttHeight
      }
    }
  }
}
</script>

<style lang="postcss" module>
.root {
  height: calc(100vh - 48px);
}
</style>
